const CODE = /(```[\s\S]*?```|`[^`\n]*`)/;
const RUN = String.raw`(?:\(\*{3,}\) ?|\*{3,})`;
const MASK = new RegExp(
  String.raw`(^|[\s([{|>:])(${RUN}(?:(?:[-.]?${RUN})+(?:[-.]?\d+)?|[-.]?\d+))(?=$|[\s.,;:!?)\]}|])`,
  'gm',
);

export const escapeMaskedValues = (text: string): string =>
  text
    .split(CODE)
    .map((part, index) =>
      index % 2 === 1
        ? part
        : part.replace(
            MASK,
            (_match, lead: string, mask: string) => `${lead}${mask.replace(/\*/g, '\\*')}`,
          ),
    )
    .join('');
